"use strict";
 require('slick-carousel');

const Sliders = () => {
    const init = () => {
        $(document).ready(function() {
            let homepage = document.getElementById('home-banner');
            if (homepage) {
                homeSlider();
            }

            var $cards_slider_container = $('.js-cards-slider-container');
            if ($cards_slider_container.length > 0) {
                const settings = {
                    infinite: true,
                    arrows: false,
                    dots: false,
                    autoplay: false,
                    touchMove: true,
                    mobileFirst: true,
                    lazyLoad: 'progressive',
                    touchThreshold: 500,
                    variableWidth: true,
                };

                $cards_slider_container.each(function () {
                    let $parent = $(this);
                    let $slider = $parent.find('.js-cards-slider');
                    
                    $slider.slick(settings);

                    $parent.find('.js-slider-prev').on('click', function() {
                        $slider.slick('slickPrev');
                    });
                    $parent.find('.js-slider-next').on('click', function() {
                        $slider.slick('slickNext');
                    });
                });
            }
        });
    };

    const homeSlider = () => {
        let $container = $('#home-banner');
        let $slider = $container.find('.main-slider').slick({
            infinite: true,
            arrows: true,
            dots: true,
            fade: true,
            speed: 1000,
            autoplay: true,
            autoplaySpeed: 5000,
            appendDots: $container.find('#dots'),
            prevArrow: $container.find('.controls .white-arrow'),
            nextArrow: $container.find('.controls .blue-arrow'),
        });

        let $secondary = $container.find('.secondary-slider').slick({
            infinite: true,
            arrows: false,
            dots: false,
            speed: 2000,
            appendDots: $container.find('#dots'),
            initialSlide: 1,
            slidesToShow: 3,
            variableWidth: true,
            touchMove: false,
            swipe: false,
        });

        // Match the arrows to title position
        let $arrows = $container.find('.arrows');

        const adjustTop = function(currentSlide) {
            let $title = $container.find('.main-slider [data-slick-index="' + currentSlide + '"] .main-inner .title'),
            titleTop = $title.offset().top,
            titleHeight = $title.height(),
            arrowHeight = $container.find('.arrows img').height();

            $arrows.css({top: titleTop + (titleHeight / 2) - (arrowHeight / 2)});
        };

        // On load
        setTimeout(() => {
            $arrows.addClass('loaded');
            $container.find('.secondary-slider').addClass('loaded');
            adjustTop($slider.slick('slickCurrentSlide'));
        }, 500);

        // On slide change
        $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
            adjustTop(nextSlide);
            $arrows.removeClass('odd').removeClass('.even');
            if (nextSlide % 2 === 0) {
                $arrows.addClass('even');
            } else {
                $arrows.addClass('odd');
            }

            $secondary.slick('slickGoTo', nextSlide + 1);
        });

        // On secondary click
        $container.find('.secondary-slider .slick-slide').click(function(e) {
           let index = $(this).data('slick-index');
           $slider.slick('slickGoTo', index);
        });

        // On resize
        let resizeTimer;
        $(window).on('resize', function(e) {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
                adjustTop($slider.slick('slickCurrentSlide'));
            }, 250);
        });
    };

    return {
        init:init
    };
};

export default Sliders;